'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var _ = require('underscore');
var GlobalConst = require('../../types/GlobalConst');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');
var propConst = require('../../constants/propConst');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 提示框组件
 */
var Alert = React.createClass({
  render: function () {
    var tx = this.props.text.split('\n');
    var title = '';
    var context = '';
    var contextArr;
    var leftText = '';
    var rightText = '';
    var lst = '';
    var btnTexts;
    if (tx.length > 0) {
      title = tx[0];
    }
    if (tx.length > 1) {
      lst = tx[tx.length - 1]
    }

    context = this.props.text.replace(title, '').replace(lst, '').trim();
    contextArr = util.Text.delimitText(context, util.Text.DM_RETURN);
    if (lst) {
      btnTexts = util.Text.delimitText(lst, util.Text.DM_COMMA, false);
      leftText = btnTexts[0];
      if (btnTexts.length > 1) {
        rightText = btnTexts[1];
      }
    }

    this.btnCount = 0;
    if (!_.isEmpty(leftText)) {
      this.btnCount++;
    }
    if (!_.isEmpty(rightText)) {
      this.btnCount++;
    }

    return (<div style={this.CSS()}>
      <div ref="title" className="title" style={this.titleCSS()}>
        <label>
          {title}
        </label>
      </div>
      <div ref="content" className="content" style={this.contentCSS()}>
        {
          contextArr.map(function (t, idx) {
            return (<p key={idx} style={{
              padding: 0,
              margin: 0,
              height: t.trim() === '' ? this.props.textSize * 1.33 : 'auto'
            }}>{t}</p>)
          }, this)
        }
      </div>
      <div ref="bottom" className="bottom" style={{
        fontSize: parseInt(this.props.textSize, 10),
        top: styleHelper.getHeight(this.props) - 35
      }}>
        {
          leftText &&
          <div className="button" style={this.btnCSS(0)}>
            <label>
              {leftText}
            </label>
          </div>
        }
        {
          rightText &&
          <div className="button" style={this.btnCSS(1)}>
            <label>
              {rightText}
            </label>
          </div>
        }
      </div>
    </div>);
  },

  btnCSS: function (index) {
    var btnPadding = 5;
    var w = styleHelper.getWidth(this.props);
    var btnWidth = this.btnCount == 2 ? (w / 2 - (btnPadding + 1) * 2) : (w - btnPadding * 2);
    var selMode = this.props.selection;
    var borderColor = GlobalConst.GLOBAL_COLOR.LIGHT_GRAY_COLOR;

    switch (selMode) {
    case appTypes.AlertYesAndNo.NO:
      if (index === 0) {
        borderColor = GlobalConst.GLOBAL_COLOR.DEFAULT_BORDER_COLOR;
      }
      break;
    case appTypes.AlertYesAndNo.YES:
      if (index === 1) {
        borderColor = GlobalConst.GLOBAL_COLOR.DEFAULT_BORDER_COLOR
      }
    }
    return {
      borderColor: borderColor,
      width: btnWidth,
      overflow: 'hidden',
      left: (index === 0 ? btnPadding : w - btnPadding - btnWidth) - 1
    }
  },
  contentCSS: function () {
    var fs = parseInt(this.props.textSize, 10);
    var textStyle = {
      fontSize: fs,
      textAlign: this.props.textAlign.toLowerCase().replace('ha', ''),
    };
    // 原来的老版本数据，有些没有 lineHeight，导致取出来为0，这时不能去设置为 0
    var lineHeight = styleHelper.builderLineHeight(this.props);
    if (lineHeight) {
      textStyle.lineHeight = lineHeight + 'px';
    } else {
      textStyle.lineHeight = '1em';
    }
    return textStyle;
  },
  titleCSS: function () {
    return {
      fontSize: parseInt(this.props.textSize, 10) + 4,
      width: styleHelper.getWidth(this.props) - 10
    }
  },

  CSS: function () {
    return styleHelper.StyleUtil(this.props).size().text().style;
  },

  componentDidMount: function () {
    this.doAdjusContentLayout();
  },

  componentDidUpdate: function () {
    this.doAdjusContentLayout();
  },

  doAdjusContentLayout: function () {
    var h = styleHelper.getHeight(this.props);
    var title = ReactDOM.findDOMNode(this.refs.title);
    var titleText = $(title).children('label');
    var lbl = titleText[0];
    var bottom = ReactDOM.findDOMNode(this.refs.bottom);
    var content = ReactDOM.findDOMNode(this.refs.content);
    var ph;
    var child = content.children;
    var i;
    var th = title.clientHeight;
    var tw = lbl.clientWidth || lbl.offsetWidth;
    var bh = bottom.clientHeight;
    var ch = h - th - bh - 10;
    var padding = 0;
    var valign = styleHelper.getPropertyValue(this.props, propConst.TEXT_V_ALIGN);
    var p;
    ph = 0;
    for (i = 0; i < child.length; i++) {
      p = child[i];
      ph += p.clientHeight;
    }
    if (valign === appTypes.VertAlign.MIDDLE) {
      padding = (ch - ph) / 2 - 8;
    } else if (valign === appTypes.VertAlign.BOTTOM) {
      padding = ch - ph - 8;
    } else {
      padding = 0;
    }
    $(content).css({paddingTop: padding, height: ch - 10, overflow: 'hidden'});
    if (tw > title.clientWidth)
      titleText.css({left: (title.clientWidth - (lbl.clientWidth || lbl.offsetWidth)) / 2, position: 'relative'})
  }
});

module.exports = Alert;



// WEBPACK FOOTER //
// ./src/views/Components/Alert.jsx